(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-collection-bestsellers"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pv-bs__viewport:not([data-init])').forEach(wrap => {
  wrap.dataset.init = '1';
  const track = wrap.querySelector('.pv-bs__track');
  const prev = wrap.querySelector('.pv-bs__nav--prev');
  const next = wrap.querySelector('.pv-bs__nav--next');
  function step(d){const t=track.querySelector('.pv-bs__tile');if(!t)return;const w=t.getBoundingClientRect().width;const g=parseFloat(getComputedStyle(track).columnGap)||0;track.scrollBy({left:d*(w+g)*2,behavior:'smooth'});}
  prev && prev.addEventListener('click', () => step(-1));
  next && next.addEventListener('click', () => step(1));
});

// Quick-add behaviour
document.querySelectorAll('[data-pv-add]:not([data-bound])').forEach(btn => {
  btn.dataset.bound = '1';
  btn.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.setAttribute('data-state', 'loading');
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      btn.setAttribute('data-state', 'done');
      // Tell theme cart to refresh
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // Try common Horizon dispatchers
      try { document.dispatchEvent(new CustomEvent('on:cart:added')); } catch(_){}
      try {
        const evt = new CustomEvent('cart-update', { detail: { source: 'pv-quick-add' }, bubbles: true });
        btn.dispatchEvent(evt);
      } catch(_){}
      // Fetch cart count and try to update common badges
      try {
        const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count], .cart-count, .header-cart__count, cart-icon-count').forEach(el => {
          if ('textContent' in el) el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: cart }));
      } catch (_) {}
      setTimeout(() => {
        btn.removeAttribute('data-state');
        btn.disabled = false;
      }, 1800);
    } catch (err) {
      btn.setAttribute('data-state', 'error');
      btn.disabled = false;
      setTimeout(() => btn.removeAttribute('data-state'), 2200);
    }
  });
});

function pvBsToggleNoScroll(){document.querySelectorAll('.pv-bs__viewport').forEach(vp => { const track = vp.querySelector('.pv-bs__track'); if (!track) return; const overflows = track.scrollWidth - vp.clientWidth > 4; vp.classList.toggle('pv-bs__viewport--no-scroll', !overflows); });}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pvBsToggleNoScroll); } else { pvBsToggleNoScroll(); }
window.addEventListener('resize', pvBsToggleNoScroll);
setTimeout(pvBsToggleNoScroll, 300);
setTimeout(pvBsToggleNoScroll, 1500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-collection-faq"] && !Shopify.designMode) return;
  try {
    
function pvInitFaq(){
  document.querySelectorAll('[data-pv-faq]:not([data-init])').forEach(wrap => {
    let container = wrap;
    const direct = [...wrap.children];
    if (direct.length === 1 && direct[0].querySelector('h3, h4')) container = direct[0];
    const items = [...container.children];
    if (items.length === 0) return;
    if (items.some(c => c.tagName === 'DETAILS')) { wrap.dataset.init = '1'; return; }
    let groups = [], current = null;
    items.forEach(el => {
      if (el.tagName === 'H3' || el.tagName === 'H4') {
        if (current) groups.push(current);
        current = { heading: el, body: [] };
      } else if (current) current.body.push(el);
    });
    if (current) groups.push(current);
    if (groups.length === 0) return;
    wrap.dataset.init = '1';
    const frag = document.createDocumentFragment();
    groups.forEach(g => {
      const det = document.createElement('details');
      const sum = document.createElement('summary');
      sum.appendChild(g.heading);
      det.appendChild(sum);
      g.body.forEach(b => det.appendChild(b));
      frag.appendChild(det);
    });
    container.innerHTML = '';
    container.appendChild(frag);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', pvInitFaq);
} else {
  pvInitFaq();
}
// Re-run on next tick in case content was rendered after script execution
setTimeout(pvInitFaq, 0);
setTimeout(pvInitFaq, 200);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-collection-pairing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pv-pair__viewport:not([data-init])').forEach(wrap => {
  wrap.dataset.init = '1';
  const track = wrap.querySelector('.pv-pair__track');
  const prev = wrap.querySelector('.pv-pair__nav--prev');
  const next = wrap.querySelector('.pv-pair__nav--next');
  function step(d){const t=track.querySelector('.pv-pair__tile');if(!t)return;const w=t.getBoundingClientRect().width;const g=parseFloat(getComputedStyle(track).columnGap)||0;track.scrollBy({left:d*(w+g)*2,behavior:'smooth'});}
  prev && prev.addEventListener('click', () => step(-1));
  next && next.addEventListener('click', () => step(1));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-mobile-skip"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;
  const pill = document.querySelector('[data-pv-skip-pill]');
  if (!pill) return;

  // Find a sensible jump target ‚Äî first product grid inside main, or fallback to the .collection element
  function findTarget(){
    // Inject anchor next to the products grid if not present
    let anchor = document.getElementById('pv-products-anchor');
    if (anchor) return anchor;
    const sels = [
      '.collection-product-grid',
      'product-grid',
      '.product-grid',
      '[data-product-grid]',
      'main .collection',
      'main #ProductGridContainer',
      'main [id*="product-grid"]',
      'main [id*="ProductGrid"]'
    ];
    let target = null;
    for (const s of sels) {
      const el = document.querySelector(s);
      if (el) { target = el; break; }
    }
    if (!target) return null;
    anchor = document.createElement('span');
    anchor.id = 'pv-products-anchor';
    anchor.style.cssText = 'display:block;position:relative;top:-80px;height:0;';
    target.parentNode.insertBefore(anchor, target);
    return anchor;
  }

  // Show pill once the user has scrolled past the hero (or 240px) and hide it when products are reached
  const showAfterY = 240;
  const targetEl = findTarget();
  let hiddenOnce = false;
  function update(){
    const y = window.scrollY || window.pageYOffset;
    let pastHero = y > showAfterY;
    let inProducts = false;
    if (targetEl) {
      const r = targetEl.getBoundingClientRect();
      // If the target is within the upper half of the viewport, we're "in products"
      if (r.top < window.innerHeight * 0.5) inProducts = true;
    }
    if (pastHero && !inProducts) {
      pill.setAttribute('data-show', '1');
      pill.removeAttribute('data-hide');
    } else {
      pill.removeAttribute('data-show');
      pill.setAttribute('data-hide', '1');
    }
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);

  // Wire up clicks (both the pill and any [data-pv-skip] link in the hero etc.)
  function smoothScrollTo(target){
    const r = target.getBoundingClientRect();
    const top = r.top + (window.scrollY || window.pageYOffset) - 70;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
  document.querySelectorAll('[data-pv-skip-pill], [data-pv-skip]').forEach(link => {
    link.addEventListener('click', (e) => {
      const t = findTarget();
      if (!t) return;
      e.preventDefault();
      smoothScrollTo(t);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
